function isCurrentPosition(position) {
    return position?.endDate?.includes('9999');
}

function isPrimaryPosition(position) {
    return position?.primary;
}

function getRelevantPosition(item) {
    return item.profile?.positions?.find(
        pos => isCurrentPosition(pos) || isPrimaryPosition(pos)
    );
}

function escapeRegExp(value = '') {
    return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function matchesCompanyConstraint(nameToCheck, agreementName, constraint) {
    if (!nameToCheck || !agreementName) {
        return false;
    }

    const normalizedNameToCheck = String(nameToCheck);
    const normalizedAgreementName = String(agreementName);

    switch (constraint) {
        case 'exact':
            return normalizedNameToCheck === normalizedAgreementName;
        case 'begins':
            return normalizedNameToCheck.startsWith(normalizedAgreementName);
        case 'contains':
            return normalizedNameToCheck.toLowerCase().includes(normalizedAgreementName.toLowerCase());
        case 'contains-exact': {
            const regex = new RegExp(`\\b${escapeRegExp(normalizedAgreementName)}\\b`, 'i');
            return regex.test(normalizedNameToCheck);
        }
        default:
            return false;
    }
}

function resolveIsCompany(item, override) {
    if (typeof override === 'boolean') {
        return override;
    }

    return item.dataType?.singular?.() === 'company';
}

function getCompanyNameToCheck(item, isCompany) {
    return (isCompany
        ? String(item.name)
        : String(getRelevantPosition(item)?.company?.name))
        || '';
}

export function isAgreementRelevant(item, agreement, options = {}) {
    if (!agreement) {
        return false;
    }
    const agreementType = agreement.agreementType;
    const isCompany = resolveIsCompany(item, options.isCompany);

    // Person agreements: check by item ID match
    if (agreementType !== 'company') {
        return !isCompany && item.id === agreement.agreementId;
    }
    // Company agreements: check by company name with constraint matching
    const nameToCheck = getCompanyNameToCheck(item, isCompany);
    return matchesCompanyConstraint(nameToCheck, agreement.agreementName, agreement.constraint);
}

export function getAgreementMutationAction(item, agreement, options = {}) {
    return isAgreementRelevant(item, agreement, options)
        ? 'update'
        : 'remove';
}
